export default __webpack_public_path__ + "static/media/papua_icon.e309ae33.png";